const SHEIN_TZ_OFFSET_MS = 8 * 60 * 60 * 1000;

function pad(n) {
  return String(n).padStart(2, '0');
}

/** 格式化为 SHEIN API 要求的 UTC+8 时间串 */
export function formatSheinDateTime(date = new Date()) {
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
  const shanghai = new Date(utcMs + SHEIN_TZ_OFFSET_MS);
  return `${shanghai.getFullYear()}-${pad(shanghai.getMonth() + 1)}-${pad(shanghai.getDate())} ${pad(shanghai.getHours())}:${pad(shanghai.getMinutes())}:${pad(shanghai.getSeconds())}`;
}

/** 默认查询最近 hours 小时（SHEIN 单次 ≤48h） */
export function buildLastHoursRange(hours = 48) {
  const end = new Date();
  const start = new Date(end.getTime() - Math.min(hours, 48) * 60 * 60 * 1000);
  return {
    startTime: formatSheinDateTime(start),
    endTime: formatSheinDateTime(end),
  };
}

/** 将 Date 转为 datetime-local 输入值 */
export function toDatetimeLocalValue(date) {
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
  const shanghai = new Date(utcMs + SHEIN_TZ_OFFSET_MS);
  return `${shanghai.getFullYear()}-${pad(shanghai.getMonth() + 1)}-${pad(shanghai.getDate())}T${pad(shanghai.getHours())}:${pad(shanghai.getMinutes())}`;
}

/** SHEIN 时间串 → datetime-local 值（供原生时间选择器展示） */
export function sheinDateTimeToLocalValue(value) {
  if (!value) return '';
  const text = String(value).trim().replace(' ', 'T');
  const match = text.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
  return match ? match[1] : '';
}

export function fromDatetimeLocalValue(value) {
  if (!value) return '';
  const normalized = value.replace('T', ' ');
  return normalized.length === 16 ? `${normalized}:00` : normalized;
}
